module.exports = __webpack_public_path__ + "static/media/6780.a8dd6fc9.jpg";